import { formatDate } from 'tools/helper'
import { svgToDataURL } from 'tools/mapHelper'

const getLocationIcon = () => {
  const iconSvg = `
            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="48px" viewBox="0 0 24 24" width="48px" fill="#EA3323"><rect fill="none" height="24" width="24"/><path d="M12,2L12,2C8.13,2,5,5.13,5,9c0,1.74,0.5,3.37,1.41,4.84c0.95,1.54,2.2,2.86,3.16,4.4c0.47,0.75,0.81,1.45,1.17,2.26 C11,21.05,11.21,22,12,22h0c0.79,0,1-0.95,1.25-1.5c0.37-0.81,0.7-1.51,1.17-2.26c0.96-1.53,2.21-2.85,3.16-4.4 C18.5,12.37,19,10.74,19,9C19,5.13,15.87,2,12,2z M12,11.75c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5 S13.38,11.75,12,11.75z"/></svg>
        `
  return svgToDataURL(iconSvg)
}

const getTooltipData = (object: any, layer: any) => {
  if (!object || layer?.id !== 'vehicle-locations-clustered') return null

  if (object.isCluster) {
    return {
      html: `<div style="padding: 12px; background: white; color: #333; border-radius: 8px; font-size: 14px; box-shadow: 0 2px 8px rgba(0,0,0,0.15); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; line-height: 1.4;">
            <div style="font-weight: 600; margin-bottom: 4px;">Cluster</div>
            <div>${object.pointCount} vehicle locations</div>
            <div style="font-style: italic; margin-top: 4px; color: #666;">Click to zoom in</div>
          </div>`,
      style: {
        backgroundColor: 'transparent',
        fontSize: '14px',
      },
    }
  } else {
    return {
      html: `<div style="padding: 12px; background: white; color: #333; border-radius: 8px; font-size: 14px; box-shadow: 0 2px 8px rgba(0,0,0,0.15); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; line-height: 1.4; max-width: 250px; word-wrap: break-word; overflow-wrap: break-word;">
             <div style="font-weight: 600; margin-bottom: 4px;">Vehicle: ${
               object.assetEldId || '-'
             }</div>
             <div style="margin-bottom: 4px;">${
               object.eldDate ? formatDate(object.eldDate, true) : '-'
             }</div>
           </div>`,
      style: {
        backgroundColor: 'transparent',
        fontSize: '14px',
      },
    }
  }
}

export { getLocationIcon, getTooltipData }
